import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

import { CollaboratorsDashboard } from '../../../features/collaborators'
import { useCombos, useCustomCombo } from '../../../features/combos/hooks/combos.hook'
import { COLLABORATORS_COMBOS_IDS } from '../constants'

export const CollaboratorsPage = () => {
  useCombos(COLLABORATORS_COMBOS_IDS)
  useCustomCombo(['empresas', 'gremios'])

  return (
    <Routes>
      <Route path="/" element={<CollaboratorsDashboard />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  )
}
